import NoData from './NoData/index.vue'
import TableList from './TableList/index.vue'
import ButtonAsync from './ButtonAsync/index.vue'
import ContentLayout from './ContentLayout/index.vue'
import SubmitBtn from './SubmitBtn/index.vue'
import BaseAvatar from './BaseAvatar/index.vue'
// // import { BaseInput, BaseTree, BaseAvatar } from 'vue-complex-component'
// import BaseEditor from './BaseEditor'
export default {
  BaseAvatar,
  NoData,
  TableList,
  ButtonAsync,
  ContentLayout,
  SubmitBtn
  // BaseEditor
}
